/**
 * EDGE-32160 / EDGE-32159: Whop's catalog serves asset/network icon URLs under a dead prefix —
 * `https://whop.com/crypto/<name>.svg` 404s, while `https://whop.com/_static/images/crypto/<name>.svg`
 * returns 200. Rewrite the known-dead prefix to the working one.
 *
 * Pure and idempotent, and a strict no-op on anything else — an already-correct Whop URL, a non-whop
 * host, a data/relative/malformed string, or null/undefined. That makes it safe to apply at every
 * render site and safe once the server-side rewrite lands (it won't double-rewrite). The `onError`
 * fallbacks at the render sites stay as belt-and-braces.
 */
export function resolveWhopIconUrl(url: string): string;
export function resolveWhopIconUrl(url: string | null | undefined): string | null;
export function resolveWhopIconUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url; // relative / malformed / no base — leave untouched
  }

  const DEAD_PREFIX = '/crypto/';
  if (parsed.hostname !== 'whop.com' || !parsed.pathname.startsWith(DEAD_PREFIX)) {
    return url;
  }

  parsed.pathname = `/_static/images/crypto/${parsed.pathname.slice(DEAD_PREFIX.length)}`;
  return parsed.toString();
}
